<template>
  <WizardStep name="info">
    <div class="row">
      <div class="col-md-8">
        <FieldGroup title="Wann bist Du am besten telefonisch erreichbar?">
          <OptionsField
            name="availableAt"
            label="Mehrere Antworten möglich"
            validation="optional"
            :options="formContext.getOptionSet('contactTimes')"
            inline
            multiple
            full-width
            as="checkbox"
          />
          <TextareaField
            name="notes"
            placeholder="Platz für weitere Anmerkungen"
            validation="optional"
          />
        </FieldGroup>
      </div>
    </div>
  </WizardStep>
</template>

<script>
import formContextAware from '../mixin/formContextAware';

export default {
  mixins: [formContextAware],
};
</script>
